import { ChainId } from '@ui/types/chain';
import { NativeToken, Token } from '@ui/types/token';
import { zeroAddress } from 'viem';

const MON = () =>
  Object.freeze<NativeToken>({
    address: null,
    decimals: 18,
    symbol: 'MON',
    image: '/tokens/MON.svg',
    displaySymbol: 'MON',
    isNative: true,
    isPayToken: true,
    isPoolToken: true,
    isStable: false,
    isTradable: false,
  });


export const ExchangeMON = () =>
  Object.freeze<Token>({
    address: zeroAddress,
    decimals: 18,
    symbol: 'MON',
    image: '/tokens/MON.svg',
    displaySymbol: 'MON',
    isNative: true,
    isPayToken: true,
    isPoolToken: true,
    isStable: false,
    isTradable: false,
  });

const createNativeToken = (chainId: ChainId): NativeToken => {
  switch (chainId) {
    case ChainId.MONAD_MAINNET:
    case ChainId.MONAD_TESTNET:
      return MON();
  }
};
const tokeMemoryCache: Partial<Record<ChainId, NativeToken>> = {};

export const getNativeToken = (chainId: ChainId): NativeToken => {
  const cache = tokeMemoryCache[chainId];
  if (cache) {
    return cache;
  }
  const token = Object.freeze(createNativeToken(chainId));
  tokeMemoryCache[chainId] = token;

  return token;
};
